import { MIN_MOVE_TIME } from 'config/game';

/**
 * Get timestamp (move time taken) from lastTime - currentTime
 */
export function getTimestamp({
  baseTimeDs,
  incrementDs,
  lastTimeDs,
  currentTimeDs,
}: {
  baseTimeDs: number;
  incrementDs: number;
  lastTimeDs?: number;
  currentTimeDs?: number;
}): number | null {
  if (!currentTimeDs) {
    return MIN_MOVE_TIME;
  }

  const startTime = lastTimeDs ?? baseTimeDs;
  const endTime = currentTimeDs - incrementDs;
  const difference = startTime - endTime;

  return Math.max(difference, MIN_MOVE_TIME);
}
